/***
**Module Name: Header 
 **File Name :  Header.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains header component details.
 ***/
import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import tmdbApi from "../../api/tmdbApi";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InactivePopup from "../../pages/inactivePopup";
import * as Config from "../../constants/Config";
import moment from "moment";
const InsideHeader = (props) => {

  const navigate = useNavigate();

  const [nameerror, setNameError] = useState("");
  const [emailerror, setEmailError] = useState("");
  const [companynameerror, setCompanyNameError] = useState("");
  const [messageerror, setMessageError] = useState("");
  const [toggle, setToggle] = useState(false);
  const [activeCheckId, setActiveCheckId] = useState("");

  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [activeClass, setActiveClass] = useState(props.activeClass ? props.activeClass : "1");

  const [profileName, setProfileName] = useState("");
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [ShowInactiveClientPopup, setShowInactiveClientPopup] = useState(false);

  const handleClose = () => {
    window.location.pathname == "/content" ? setActiveClass("1") :
      window.location.pathname == "/enquire" ? setActiveClass("2") :
        window.location.pathname == "/aboutus" ? setActiveClass("4") :
          window.location.pathname == "/team" ? setActiveClass("5") :
            // window.location.pathname == "/partners" ? setActiveClass("6")
            window.location.pathname == "/news" ? setActiveClass("6") :
              window.location.pathname == "/contactus" ? setActiveClass("7") :
                window.location.pathname == "/auction" ? setActiveClass("8") :
                  window.location.pathname == "/preference" ? setActiveClass("10") :
                    window.location.pathname == "/profile" ? setActiveClass("9") : setActiveClass("0")
    setShow(false);
  }

  // console.log("props-------------->", props)

  const [config, setConfig] = useState({});
  // const [clientData , setClientData] = useState([]);


  const { clientData, setClientData1, searchId, setSearchId, inactiveFlag, setInactiveFlag, formValues, setFormValues, GetClientDataFunction, wishlistCount, setwishlistCount, wishListData, setWishListData, showCategoryData, setShowCategoryData, setInitialCategoriesData1, hideMenu, setHideMenu, isShowMyContent, setIsShowMyContent, pageNumber, setPageNumber, assetTotal, setAssetTotal, perpage, setPerpage, totalPagesArray, setTotalPagesArray, totalPages, setTotalPages, setGrid, setList, setMenuCategoryName, SetSearchTitleInput,
    selectedOptions, formatsClick, setFormatsClick, setSelectedOptions, selectedData, setSelectedData, setFormValuesForContent, multiSelectFields, setMultiSelectFields, setActivePayload, searchPayload, setSearchPayload, setActiveFieldsObj, setParamType,
    setActiveTab
  } = useContext(contentContext)
  //  console.log('activeClass',activeClass)
  useEffect(() => {
    if (window.site) {
      setConfig(window.site);

    }
    // GetClientDataFun()
    if (!formatsClick) {
      GetClientDataFunction();
    }
  }, [window.site]);

  if (config.common && config.common.imagesCDN) {
    var img = config.common.imagesCDN;
  }
  // console.log('clientData',clientData)
  const [recommend, setRecommend] = useState({ username: '', useremail: '', name: '', email: '', number: '', companyname: '', message: 'I was going through this portal and thought it might be interesting to you. This is a digital content marketplace where one can syndicate and acquire content. It is a global platform (Media and Entertainment) and seems to have a wide variety of content. I hope you like it.' });

  const handleProfile = (e) => {
    setFormValuesForContent([])
    setActiveTab("title")
    navigate("/profile");
  }
  const handlePreference = (e) => {
    // setSearchPayload({})
    setFormValuesForContent([])
    setActiveClass("10")
    setActiveTab("title")
    navigate("/preference");
  }
  const handleBack = (e) => {
    navigate("/content");
    setShowCategoryData(true);

  }
  const handleLogout = (e) => {

    localStorage.removeItem("token");
    localStorage.removeItem("clientid");
    localStorage.removeItem("login");
    localStorage.removeItem("wishlistcount");
    localStorage.removeItem("currentSessionClientTime")
    localStorage.removeItem("previousid");
    localStorage.removeItem("formatsClick");
    localStorage.removeItem("comingFromEmail");
    setFormatsClick(false)
    signoutsession()
    unSetValues()
    navigate("/");

  }

  const handleChangePwd = (e) => {

    setActiveClass("6")
    setActiveTab("title")
    navigate("/profile");
  }
  const handleCart = () => {
    setFormValuesForContent([])
    setActiveTab("title")
    navigate("/cart");
  }
  const unSetValues = () => {
    setFormValuesForContent([])
    setHideMenu(false)
    setInitialCategoriesData1([])
    setShowCategoryData(true)
    setMenuCategoryName("")
    setClientData1([])
    setParamType("")
    setFormValues([])
    setPageNumber(1)
    setAssetTotal(0)
    setPerpage(18)
    setTotalPagesArray(0)
    setGrid(true);
    setList(false);
    setTotalPages(0)
    setSelectedOptions([])
    setMultiSelectFields([])
    SetSearchTitleInput("")
    setActivePayload({})
    setSearchPayload({})
    setIsShowMyContent(false)

  }
  const AddNotify = () => toast.success('Recommendation Sent!', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)

  const Recommend = async () => {
    try {
      setActiveCheckId("active")
      const response = await tmdbApi.Recommend({
        "username": clientData.name || "",
        "useremail": clientData.personalemail || "",
        "name": recommend.name || "",
        "email": recommend.email || "",
        "phone": recommend.number || "",
        "companyname": recommend.companyname || "",
        "message": recommend.message || "",
        "activity": {
          pageVisited: "Recommend",
          action: "Recommend",
          time: moment().format("hh:mm A"),
          actionDescription: recommend.email,
          icon: "recommend"
        }

      });

      if (response.result == "Invalid token or Expired") {
        setShowSessionPopupup(true)

      } else if (response.result == "Client inactived") {
        setInactiveFlag(true)

      } else {

        AddNotify()
        console.log(response);
      }
      setRecommend({ ...recommend, ["name"]: "", ["email"]: "", ["number"]: "", ["companyname"]: "" })
      setActiveCheckId("")
      handleClose()

    } catch {
      handleClose()
      setRecommend({ ...recommend, ["name"]: "", ["email"]: "", ["number"]: "", ["companyname"]: "" })
      setActiveCheckId("")
      console.log("error");
    }
  };
  const signoutsession = async () => {
    try {
      const response = await tmdbApi.SignOutUser({ emailId: clientData.personalemail });
      console.log(response);

    } catch {
      console.log("error");
    }
  }

  const handleChange = (e) => {
    setRecommend({ ...recommend, [e.target.name]: e.target.value });
  }

  const handleRecommend = (e) => {

    let flag = true

    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(recommend.email)) {

      setEmailError("");
      setTimeout(function () { setEmailError("") }, 2000)
    } else if (!regEx.test(recommend.email) && recommend.email !== "") {
      setEmailError("Email is Not Valid");

      flag = false;
      setTimeout(function () { setEmailError("") }, 2000)
    }

    if (recommend.name === "") {
      setNameError("Please enter Name");
      flag = false;
    }
    if (recommend.email === "") {
      setEmailError("Please enter Email");
      flag = false;
    }
    if (recommend.companyname === "") {
      setCompanyNameError("Please enter Company Name");
      flag = false;
    }
    if (recommend.message === "") {
      setMessageError("Please enter Message");
      flag = false;
    }

    if (flag) {
      if (activeCheckId == "") {
        Recommend();
      }
    }

  }
  const getToken = (e) => {
    console.log('localStorage.getItem("token")', localStorage.getItem("token"))
  }
  //  getToken();
  const handleMarket = (e, val) => {
    setMenuCategoryName('')
    setSelectedData("")
    setSearchPayload({})
    setActiveClass(val);
    setInitialCategoriesData1([])
    setParamType("")
    navigate("/content")
    setShowCategoryData(true)
    setHideMenu(true)
    setActiveTab("title")
    setSearchId("")
  }
  const handleEnquire = (e, val) => {
    setActiveClass(val);
    setFormValuesForContent([])
    setActiveTab("title")
    navigate("/enquire")
  }
  const handleAuction = (e, val) => {
    navigate("/auction");
    setActiveClass(val);
    setActiveTab("title")
    console.log("vallllllllllllllllll", val)
  }
  console.log("activeClasssssssssss", activeClass)
  const handleShow = (e, val) => {
    setShow(true);
    setActiveClass(val);
    setActiveTab("title")
  }

  const handleTeam = (e, val) => {
    setActiveClass(val);
    setFormValuesForContent([])

    setInitialCategoriesData1([])
    setSearchPayload({})
    navigate("/team");
  }
  const handleNews = (e, val) => {
    setActiveClass(val);
    setFormValuesForContent([])
    setInitialCategoriesData1([])
    setSearchPayload({})
    navigate("/blog");
  }
  const handleAboutus = (e, val) => {
    setActiveClass(val);
    setFormValuesForContent([])

    setInitialCategoriesData1([])
    setSearchPayload({})
    setActiveTab("title")
    navigate("/aboutus");

  }
  const handlePartners = (e, val) => {
    setActiveClass(val);
    setFormValuesForContent([])
    setInitialCategoriesData1([])
    setSearchPayload({})
    navigate("/partners");
  }
  const handleContact = (e, val) => {
    setActiveTab("title")
    setActiveClass(val);
    setFormValuesForContent([])

    setSearchPayload({})
    setInitialCategoriesData1([])
    navigate("/contactus");
  }
  let myArray = []
  myArray = clientData && clientData.name?.split(" ");



  const handleFocusName = (e) => {
    setNameError("");
  }
  const handleFocusEmail = (e) => {
    setEmailError("");
  }
  const handleFocusCompanyName = (e) => {
    setCompanyNameError("");
  }
  const handleFocusMessage = (e) => {
    setMessageError("");
  }
  const toggleClass = () => {
    setToggle(!toggle);
  };



  return (

    <>
      {inactiveFlag && <InactivePopup />}
      {!inactiveFlag && showSessionPopupup && <SessionPopup />}

      <header id="header" className="fixed-top dark-header inner-header navbar navbar-expand-lg">
        <div className="container-fluid">

          {/* LOGO */}
          <a className="navbar-brand" onClick={handleBack}>
            <img
              src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`}
              id="logo-img"
              alt="Logo"
            />
          </a>

          {/* TOGGLE BUTTON */}
          <button
            className="navbar-toggler text-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon inner-resp-menu"></span>
          </button>

          {/* COLLAPSIBLE SECTION */}
          <div className="collapse navbar-collapse" id="navbarNav">

            {/* MENU */}
            <ul className="navbar-nav me-auto mt-3 mt-lg-0 inner-nav-menu" id="nav-list">

              <li className="nav-item">
                <a className={`nav-link ${activeClass === "1" ? "active" : ""}`}  id="nav-marketplace" onClick={(e) => handleMarket(e, "1")}>Marketplace</a>
              </li>

              {!isShowMyContent && clientData?.type !== "SELLER" && (
                <li className="nav-item">
                  <a className={`nav-link ${activeClass === "2" ? "active" : ""}`}  id="nav-orders" onClick={(e) => handleEnquire(e, "2")}>Orders</a>
                </li>
              )}

              <li className="nav-item">
                <a className={`nav-link ${activeClass === "3" ? "active" : ""}`} id="nav-recommend" onClick={(e) => handleShow(e, "3")}>Recommend</a>
              </li>

              <li className="nav-item">
                <a className={`nav-link ${activeClass === "4" ? "active" : ""}`}  id="nav-about" onClick={(e) => handleAboutus(e, "4")}>About Us</a>
              </li>

              <li className="nav-item">
                <a className={`nav-link ${activeClass === "6" ? "active" : ""}`} id="nav-news" onClick={(e) => handleNews(e, "6")}>Blog</a>
              </li>

              <li className="nav-item">
                <a className={`nav-link ${activeClass === "7" ? "active" : ""}`} id="nav-contact" onClick={(e) => handleContact(e, "7")}>Contact Us</a>
              </li>
            </ul>

            {/* ACTION BUTTONS */}
            <div className="nav-actions inner-nav-btns" id="nav-actions">
              <div
                className="btn-group mr-2 nav-grp-btns ms-3"
                id="preferences-btn-group"
              >
                {clientData.type !== "SELLER" && (
                  <button
                    type="button"
                    id="preferences-btn"
                    className={`${activeClass === "8" ? "active" : ""} btn btn-primary`}
                    onClick={handlePreference}
                  >
                    Preferences
                  </button>
                )}
              </div>
              {!isShowMyContent && clientData && clientData.type != "SELLER" ? (
                <button
                  type="button"
                  id="cart-btn"
                  className="nav-btn ms-3"
                  onClick={handleCart}
                >
                  <div className="btn-cont">
                    {(wishlistCount || parseInt(localStorage.getItem("wishlistCount"))) >
                      0 ? (
                      <span id="cart-count" className="count blueBg">
                        {wishlistCount || localStorage.getItem("wishlistCount")}
                      </span>
                    ) : null}
                    <span className="material-symbols-outlined"> shopping_cart </span>
                  </div>
                  Cart
                </button>
              ) : null}

              <Dropdown className="dropdown user-dd ms-3" id="user-dropdown">
                <Dropdown.Toggle id="user-dropdown-toggle" className="btn dropdown-toggle">
                  <div className="profile-thumb md-2" id="profile-thumb">
                    <p>
                      {myArray && myArray.length > 1
                        ? myArray &&
                        myArray.length > 0 &&
                        myArray[0]?.slice(0, 1)?.toUpperCase() +
                        myArray[1]?.slice(0, 1)?.toUpperCase()
                        : clientData && clientData.name?.slice(0, 2)?.toUpperCase()}
                    </p>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu id="user-dropdown-menu">
                  <div className="avatar-card" id="avatar-card">
                    <div className="avatar-lg">
                      <div className="profile-thumb md-2">
                        <p>
                          {myArray && myArray.length > 1
                            ? myArray &&
                            myArray.length > 0 &&
                            myArray[0]?.slice(0, 1)?.toUpperCase() +
                            myArray[1]?.slice(0, 1)?.toUpperCase()
                            : clientData && clientData.name?.slice(0, 2)?.toUpperCase()}
                        </p>
                      </div>
                    </div>
                    <h6 className="username" id="user-name">
                      {clientData && clientData.name}
                    </h6>
                    <p className="phone-number" id="user-phone">
                      {clientData && clientData.personalphone}
                    </p>
                    <p className="sm-badge badge" id="user-type">
                      {clientData && clientData.type
                        ? clientData.type == "BOTH"
                          ? "BUYER, SELLER"
                          : clientData.type
                        : "BUYER"}
                    </p>
                  </div>
                  <Dropdown.Item id="dropdown-profile" onClick={handleProfile}>
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item
                    id="dropdown-preferences"
                    onClick={handlePreference}
                    className={`${!isShowMyContent && clientData && clientData.type != "SELLER"
                      ? ""
                      : "seller_preferences_hide"
                      }`}
                  >
                    Preferences
                  </Dropdown.Item>
                  <Dropdown.Item
                    id="dropdown-password"
                    className="dropdown_password"
                    onClick={handleProfile}
                  >
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item
                    id="dropdown-logout"
                    className="dropdown_logout"
                    onClick={handleLogout}
                  >
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </header>


      <Modal show={show} id="recommend-modal">

        <div className="modal-header" id="recommend-modal-header">
          <a className="navbar-brand">
            <img
              src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`}
              alt="Logo"
              id="recommend-modal-logo"
            />

          </a>

          <h4 className="modal-title pos-center" id="recommend-modal-title">
            Recommend Orasi Media
          </h4>
          <a
            href="#"
            className="btn-close"
            data-bs-dismiss="modal"
            onClick={handleClose}
            style={{ cursor: "pointer", textDecoration: "none" }}
          >
            <span className="material-symbols-outlined">close</span>
          </a>
        </div>

        <div className="modal-body" id="recommend-modal-body">
          <div className="container recomended-wrapper" id="recommend-container">
            <div className="row" id="recommend-user-row">
              <div className="col-md-6 col-lg-6">
                <div className="mb-1">
                  <label htmlFor="user-name-input" className="form-label">
                    Name<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="user-name-input"
                    name="username"
                    value={clientData && clientData.name}
                    placeholder="Enter Name"
                    disabled
                  />
                </div>
              </div>

              <div className="col-md-6 col-lg-6">
                <div className="mb-1">
                  <label htmlFor="user-email-input" className="form-label">
                    Email Id<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="user-email-input"
                    name="useremail"
                    value={clientData && clientData.personalemail}
                    placeholder="Enter Email Id"
                    disabled
                  />
                </div>
              </div>
            </div>

            <h6 className="mt-2" id="recommend-to-title">Recommend to</h6>

            <div className="row" id="recommend-fields-row">
              <div className="col-md-6 col-lg-6">
                <div className="mb-2">
                  <label htmlFor="recommend-name-input" className="form-label">
                    Name<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="recommend-name-input"
                    name="name"
                    onChange={(e) => handleChange(e)}
                    value={recommend && recommend.name}
                    placeholder="Enter Name"
                    onFocus={handleFocusName}
                  />
                  {nameerror !== "" && (
                    <span className="errormsg" id="name-error">{nameerror}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-lg-6">
                <div className="mb-2">
                  <label htmlFor="recommend-email-input" className="form-label">
                    Email Id<span>*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="recommend-email-input"
                    name="email"
                    onChange={(e) => handleChange(e)}
                    value={recommend && recommend.email}
                    placeholder="Enter Email Id"
                    onFocus={handleFocusEmail}
                  />
                  {emailerror !== "" && (
                    <span className="errormsg" id="email-error">{emailerror}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-lg-6">
                <div className="mb-2">
                  <label htmlFor="recommend-companyname-input" className="form-label">
                    Company Name<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="recommend-companyname-input"
                    name="companyname"
                    onChange={(e) => handleChange(e)}
                    value={recommend && recommend.companyname}
                    placeholder="Enter Company Name"
                    onFocus={handleFocusCompanyName}
                  />
                  {companynameerror !== "" && (
                    <span className="errormsg" id="companyname-error">{companynameerror}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-lg-6">
                <div className="mb-2">
                  <label htmlFor="recommend-phone-input" className="form-label">
                    Contact Number
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="recommend-phone-input"
                    name="number"
                    onChange={(e) => handleChange(e)}
                    value={recommend && recommend.number}
                    placeholder="Enter Phone Number"
                  />
                </div>
              </div>

              <div className="col-md-12 col-lg-12">
                <div className="mb-2">
                  <label htmlFor="recommend-message-input" className="form-label">
                    Recommend Text<span>*</span>
                  </label>
                  <textarea
                    name="messages"
                    rows="6"
                    id="recommend-message-input"
                    onChange={(e) => handleChange(e)}
                    value={recommend && recommend.message}
                    className="form-control"
                    onFocus={handleFocusMessage}
                    placeholder="Enter Recommend Text"
                  />
                  {messageerror !== "" && (
                    <span className="errormsg" id="message-error">{messageerror}</span>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>

        <Modal.Footer id="recommend-modal-footer">
          {error != "" ? (
            <span className="errormsg" id="general-error">{error}</span>
          ) : ""}

          <div className="modal-footer" id="recommend-footer-buttons">
            <button
              className="fill_btn yellow-gradient float-end"
              id="recommend-submit-btn"
              onClick={handleRecommend}
            >
              {activeCheckId === "active" ? (
                <img
                  src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                  className="loading-icon"
                  id="recommend-loading-icon"
                />
              ) : null}
              Recommend
            </button>
            <div className="clearfix"></div>
          </div>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
        limit={1}
      />
    </>
  );
};

export default InsideHeader;